import request from '@/utils/request'

export function getAssistantName(data) {
    return request({
        url: '/backend/assistant/getAssistantName',
        method: 'post',
        data: data
    })
}

//助教列表
export function getAssistantList(data) {
    return request({
        url: '/backend/assistant/getAssistantList',
        method: 'post',
        data: data
    })
}

//获取助教信息
export function getAssistantInfo(data) {
    return request({
        url: '/backend/assistant/getAssistantInfo',
        method: 'post',
        data: data
    })
}


//修改助教信息
export function updateAssistantInfo(data) {
    return request({
        url: '/backend/assistant/updateAssistantInfo',
        method: 'post',
        data: data
    })
}

//修改助教排序信息
export function updateAssistantSort(data) {
    return request({
        url: '/backend/assistant/updateAssistantSort',
        method: 'post',
        data: data
    })
}


//修改助教排序信息
export function getAssistantTreadsList(data) {
    return request({
        url: '/backend/assistant/getAssistantTreadsList',
        method: 'post',
        data: data
    })
}